import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { GAClickButton } from 'utils/analytics/analytics-events';
import { ROW_STEP } from '../../../../../../../../constants';
import { selectTopCategories } from '../../../../../selectors';
import { selectSelectedFilterItems } from '../../../selectors';
import { useGetNumberOfRows } from './use-get-number-of-rows';

export const useTopCategoriesContainer = () => {
	const selectedFilterItems = useSelector(selectSelectedFilterItems);
	const topCategories = useSelector(selectTopCategories);

	const {
		numberOfAllRows,
		numberOfShownRows,
		numberOfCardsInARow,
		setNumberOfShownRows,
	} = useGetNumberOfRows(selectedFilterItems, topCategories, ROW_STEP);

	const [isShowMoreCategoriesBtnVisible, setShowMoreCategoriesBtnVisibility] = useState(
		numberOfAllRows > ROW_STEP
	);

	const checkShowMoreCategoriesBtnVisibility = useCallback(() => {
		const isBtnVisible = !(numberOfAllRows <= numberOfShownRows);
		setShowMoreCategoriesBtnVisibility(isBtnVisible);
	}, [numberOfAllRows, numberOfShownRows]);

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => checkShowMoreCategoriesBtnVisibility(), [numberOfShownRows, numberOfAllRows]);

	const showMoreCategoriesBtnHandler = useCallback(() => {
		setNumberOfShownRows(prevState => prevState + ROW_STEP);
		GAClickButton({
			elementBlock: 'serviceList',
			elementName: 'Список услуг',
			elementText: 'Показать еще',
		});
	}, [setNumberOfShownRows]);

	return {
		selectedFilterItems,
		topCategories,
		numberOfCardsInARow,
		numberOfShownRows,
		isShowMoreCategoriesBtnVisible,
		showMoreCategoriesBtnHandler,
	};
};
